import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

export const BUDGET_OPTIONS = ['$50–$100', '$100–$250', '$250–$500', '$500+'];

const PRIORITY_OPTIONS = [
  { value: 'staying-within-budget', label: 'Staying within budget' },
  { value: 'high-end-design', label: 'High-end design' },
  { value: 'fast-turnaround', label: 'Fast turnaround' },
  { value: 'flexibility', label: 'Flexibility & customization' },
];

export const QuantitySection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 5: QUANTITY & PRINT DETAILS (If Applicable)</h3>

    <div>
      <Label htmlFor="quantity" className="text-charcoal-ink">Estimated Quantity Needed (if printing)</Label>
      <Input
        id="quantity"
        value={formData.quantity}
        onChange={(e) => set('quantity', e.target.value)}
        className="bg-white border-stone-taupe/20"
        placeholder="e.g., 50 favor bags"
      />
    </div>

    <div>
      <Label htmlFor="size" className="text-charcoal-ink">Preferred Size (if known)</Label>
      <Input
        id="size"
        value={formData.size}
        onChange={(e) => set('size', e.target.value)}
        className="bg-white border-stone-taupe/20"
        placeholder="e.g., 5x7 inches, A4"
      />
    </div>
  </div>
);

export const BudgetSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 6: BUDGET & EXPECTATIONS</h3>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Estimated Budget Range *</Label>
      <RadioGroup value={formData.budget} onValueChange={(value) => set('budget', value)}>
        {BUDGET_OPTIONS.map((budget) => (
          <div key={budget} className="flex items-center space-x-2">
            <RadioGroupItem value={budget} id={budget} />
            <Label htmlFor={budget} className="text-charcoal-ink font-normal cursor-pointer">{budget}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">What is most important to you? *</Label>
      <RadioGroup value={formData.priority} onValueChange={(value) => set('priority', value)}>
        {PRIORITY_OPTIONS.map((option) => (
          <div key={option.value} className="flex items-center space-x-2">
            <RadioGroupItem value={option.value} id={option.value} />
            <Label htmlFor={option.value} className="text-charcoal-ink font-normal cursor-pointer">{option.label}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  </div>
);

export const TimelineSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 7: TIMELINE</h3>

    <div>
      <Label htmlFor="deadline" className="text-charcoal-ink">When do you need the final designs delivered? *</Label>
      <Input
        id="deadline"
        type="date"
        required
        value={formData.deadline}
        onChange={(e) => set('deadline', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label htmlFor="additionalInfo" className="text-charcoal-ink">Anything else I should know about your vision?</Label>
      <Textarea
        id="additionalInfo"
        value={formData.additionalInfo}
        onChange={(e) => set('additionalInfo', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[120px]"
        placeholder="Share any additional details that will help bring your vision to life..."
      />
    </div>
  </div>
);

export const TermsSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 8: TERMS & SUBMISSION</h3>

    <div className="flex items-start space-x-3">
      <Checkbox
        id="terms"
        checked={formData.agreedToTerms}
        onCheckedChange={(checked) => set('agreedToTerms', checked)}
        required
      />
      <Label htmlFor="terms" className="text-charcoal-ink font-normal cursor-pointer leading-relaxed">
        I understand that custom designs start at $50, pricing may vary based on scope, and production does not begin until payment is received.
      </Label>
    </div>
  </div>
);
